module.exports = __webpack_public_path__ + "static/media/delete.19c0aea1.svg";